import { viteCurrentPortal } from '../constants/env';
const CURRENT_PORTAL = viteCurrentPortal();
export const anonymousUserContext = {
    kind: 'user',
    anonymous: true,
    key: 'shared-anonymous',
    portal: CURRENT_PORTAL,
};
export const convertToLDIdentityContext = ({ user }) => {
    if (!user) {
        return anonymousUserContext;
    }
    const ldUserName = `${user.firstName} ${user.lastName}`;
    const userContext = {
        kind: 'user',
        key: `${user.id}`,
        name: ldUserName,
        email: user.email,
        role: user.actorType,
        portal: CURRENT_PORTAL,
    };
    return userContext;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydFRvTERJZGVudGl0eUNvbnRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvY29udmVydFRvTERJZGVudGl0eUNvbnRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFHckQsTUFBTSxjQUFjLEdBQUcsaUJBQWlCLEVBQUUsQ0FBQztBQUUzQyxNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRztJQUNsQyxJQUFJLEVBQUUsTUFBTTtJQUNaLFNBQVMsRUFBRSxJQUFJO0lBQ2YsR0FBRyxFQUFFLGtCQUFrQjtJQUN2QixNQUFNLEVBQUUsY0FBYztDQUN2QixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sMEJBQTBCLEdBQUcsQ0FBQyxFQUFFLElBQUksRUFBMEIsRUFBRSxFQUFFO0lBQzdFLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUNWLE9BQU8sb0JBQW9CLENBQUM7SUFDOUIsQ0FBQztJQUVELE1BQU0sVUFBVSxHQUFHLEdBQUcsSUFBSSxDQUFDLFNBQVMsSUFBSSxJQUFJLENBQUMsUUFBUSxFQUFFLENBQUM7SUFFeEQsTUFBTSxXQUFXLEdBQXdCO1FBQ3ZDLElBQUksRUFBRSxNQUFNO1FBQ1osR0FBRyxFQUFFLEdBQUcsSUFBSSxDQUFDLEVBQUUsRUFBRTtRQUNqQixJQUFJLEVBQUUsVUFBVTtRQUNoQixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7UUFDakIsSUFBSSxFQUFFLElBQUksQ0FBQyxTQUFTO1FBQ3BCLE1BQU0sRUFBRSxjQUFjO0tBQ3ZCLENBQUM7SUFFRixPQUFPLFdBQVcsQ0FBQztBQUNyQixDQUFDLENBQUMifQ==